var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumulene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#2CB34A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.9,353.2h6.6v14.3H143v-14.3h6.6v33H143v-12.9h-13.5v12.9h-6.6V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.3,372.6v-19.4h6.6v18.9c0,4.7,2.4,8.4,6.8,8.4c4,0,6.9-3.1,6.9-8.4v-18.9h6.6v19.4 c0,8.6-5,14.1-13.4,14.1C161.7,386.6,156.3,381.6,156.3,372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9,353.2h6.6l10.1,18.8h0.1l10.1-18.8h6.6v33h-6.5v-20.4h-0.1l-8,14.2h-4.2l-8-14.2h-0.1v20.5h-6.5V353.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.1,372.6v-19.4h6.6v18.9c0,4.7,2.4,8.4,6.8,8.4c4,0,6.9-3.1,6.9-8.4v-18.9h6.6v19.4 c0,8.6-5,14.1-13.4,14.1C235.5,386.6,230.1,381.6,230.1,372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.6,353.2h6.7v27.2h14.6v5.8h-21.3V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.9,353.2H311v5.8h-14.7v8h11.7v5.7h-11.7v7.7H312v5.8h-22.1V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.7,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6l-14.7-21.8h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.7,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.7,98.7c-54.4,0-98.5,44.1-98.5,98.5s44.1,98.5,98.5,98.5s98.5-44.1,98.5-98.5S302.1,98.7,247.7,98.7z  M214.5,246.5h-10.1v-48.2h-8.5v48.2h-10.1v-104h10.1v48.4h8.5v-48.4h10.1V246.5z M256.4,232.8c0,2.6-0.4,4.8-1.2,6.6 s-1.8,3.3-3,4.5s-2.7,2.1-4.3,2.6s-3.3,0.8-4.8,0.8h-2.4c-1.7,0-3.3-0.3-4.9-0.8c-1.6-0.5-3-1.4-4.2-2.6s-2.3-2.7-3-4.5 c-0.8-1.8-1.2-4-1.2-6.6v-90.3h10.1v88.8c0,2.8,0.4,4.7,1.2,5.9c0.8,1.1,1.7,1.7,2.8,1.7h0.9c1.1,0,2-0.6,2.8-1.7 c0.8-1.1,1.2-3.1,1.2-5.9v-88.8h10.1v90.3H256.4z M309.5,246.5h-8.3v-73.2H301l-8.2,73.2h-7.4l-8.2-73.2H277v73.2h-8.5v-104h13.1 l7.3,65.8h0.2l7.4-65.8h12.9v104H309.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumulene);
export default __webpack_public_path__ + "static/media/HUMULENE.a4e17154a2d6f84cb76a1fb5597b4b72.svg";
export { ForwardRef as ReactComponent };